/* istanbul ignore file */
import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import './assets/sass/style.scss'
import './assets/sass/plugins.scss'
import './assets/sass/style.react.scss'
import { AppRoutes } from './routing/AppRoutes'
import { Provider } from 'react-redux'
import { store } from './redux'
import { ignorarErrorResizeObserver } from './utils/IgnorarErrorResizeObserver'

ignorarErrorResizeObserver()

// El titulo se lee de configuracion runtime generada por `env.sh`, no de variables compiladas.
ReactDOM.render(window._env_.REACT_APP_TITULO, document.getElementById('title-root'))

/**
 * Punto de montaje de la SPA.
 *
 * Redux debe envolver el router porque la decision entre rutas publicas y
 * privadas depende del usuario autenticado guardado en el store.
 */
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
